export function setSiteTitle(title = ''): void {
  document.title = title + (title && ' - ') + '第11回 中文东方人气投票'
}
